if (!customElements.get("warranty-accordion")) {
  const selectors = {
    ACCORDION_HEADER_SELECTOR: ".js-accordion-header",
    ACTIVE_CLASS: "active",
  };
  
  class WarranryAccordion extends HTMLElement {
    constructor() {
      super();
  
      this.accordionHeaderEls = this.querySelectorAll(
        selectors.ACCORDION_HEADER_SELECTOR
      );
    }
  
    connectedCallback() {
      this.bindEvents();
    }
  
    bindEvents() {
      this.accordionHeaderEls.length &&
        this.accordionHeaderEls.forEach((accordionHeader) => {
          accordionHeader.addEventListener("click", () => {
            if (!accordionHeader.classList.contains(selectors.ACTIVE_CLASS)) {
              this.removeClassActive(this.accordionHeaderEls)
              accordionHeader.classList.add(selectors.ACTIVE_CLASS)
            } else {
              accordionHeader.classList.remove(selectors.ACTIVE_CLASS)
            }
          });
        });
    }
  
    removeClassActive(items) {
      if(!items.length) reutrn
  
      items.forEach((item) => {
        item.classList.remove(selectors.ACTIVE_CLASS)
      });
    }
  }
  customElements.define("warranty-accordion", WarranryAccordion);
}
